"use strict";
var r, n;
function e() {
  return n || (n = 1, r = Function.prototype.call), r;
}
export {
  e as __require
};
//# sourceMappingURL=index.es324.js.map
